import { redirect } from '@tanstack/react-router';

import { Profile } from '../types/profile.types';

import { ROLES } from '@data-access';

import { canAccess } from './can-access';
import { Permission } from './permission';

const DEFAULT_APP_PATH = '/os/dashboard';
const SAMPLER_HOME_PATH = '/os/ngp-sampling-assignment';
const USERS_ROUTE_PREFIX = '/users';

export interface AuthRouteContext {
  isAuthenticated: boolean;
  isUserLoading: boolean;
  user?: Profile;
}

export function resolveDefaultAppPath(user?: Profile | null): string {
  return user?.user_access === ROLES.SAMPLER
    ? SAMPLER_HOME_PATH
    : DEFAULT_APP_PATH;
}

export function isUsersAdminRoute(pathname: string): boolean {
  return (
    pathname === USERS_ROUTE_PREFIX ||
    pathname.startsWith(`${USERS_ROUTE_PREFIX}/`)
  );
}

export function shouldDeferRouteGuard(auth: AuthRouteContext): boolean {
  return auth.isAuthenticated && auth.isUserLoading;
}

export function assertPermissionOrRedirect(
  auth: AuthRouteContext,
  permission: Permission,
): void {
  if (shouldDeferRouteGuard(auth)) {
    return;
  }

  const role = auth.user?.user_access;
  if (!canAccess(role, permission)) {
    throw redirect({ to: resolveDefaultAppPath(auth.user) });
  }
}
